import { API_ENDPOINTS } from "../../constants";
import {
  get,
  put,
  uploadFile,
  postForFileAsResponse,
  getForFileAsResponse,
} from "../../api/index";
import store from "../../store";

const { APIS } = API_ENDPOINTS;
/*
========================================
   Quotes Document Details Functions
========================================
*/
const fetchQuoteDocumentDetails = id =>
  new Promise((resolve, reject) => {
    get(`${APIS.QUOTES}/${id}/documents`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const saveQuoteDocumentConfigDetails = () =>
  new Promise((resolve, reject) => {
    const state = store.getState();
    const quoteID = state.QuotesStore.quoteDetails.id;
    const quoteDocumentInfo = {};
    quoteDocumentInfo.quote_id = quoteID;
    quoteDocumentInfo.document_config = {
      ...state.QuoteDocumentStore.quoteDocumentConfig,
    };
    put(`${APIS.QUOTES}/${quoteID}/document/config`, quoteDocumentInfo)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const uploadRawQuoteDocument = filevalue =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", filevalue);

    uploadFile(`${APIS.UPLOAD_QUOTE_DOCUMENT}`, formData)
      .then(res => {
        if (!res.Components) {
          reject(Error("Excepted a key `Components` in response"));
        }
        resolve(res.Components);
      })
      .catch(error => {
        reject(error);
      });
  });

const exportDocument = (exportType, exportContent) =>
  new Promise((resolve, reject) => {
    postForFileAsResponse(`${APIS.EXPORT_DOCX_V2}/${exportType}`, exportContent)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

const uploadRevisedDocument = (fileDetails, name, docNo) =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("doc", fileDetails);
    formData.append("opp_name", name);
    formData.append("doc_no", docNo);
    uploadFile(`${APIS.UPLOAD_REVISED_DOCUMENT}`, formData)
      .then(res => {
        if (!res.Document) {
          reject(Error("Excepted a key `Document` in response"));
        }
        resolve(res.Document);
      })
      .catch(error => {
        reject(error);
      });
  });

const getDocInPdf = docId =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(`${APIS.FETCH_DOC_SIGN_PDF}/${docId}/signed`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export {
  fetchQuoteDocumentDetails,
  saveQuoteDocumentConfigDetails,
  uploadRawQuoteDocument,
  uploadRevisedDocument,
  exportDocument,
  getDocInPdf,
};



// WEBPACK FOOTER //
// ./src/actions/QuoteDocuments/services.js